/**
 * MLD-5240
 */
export default {
  engagementScoreColor(score) {
    // @see https://chat.openai.com/c/6ca76b61-3eb5-4e12-8286-8e74f0ed76a8
    if (score > 90) {
      return '#4caf50';
    }
    if (score > 70) {
      return '#8bc34a';
    }
    if (score > 40) {
      return '#ffc107';
    }
    if (score > 15) {
      return '#ff9800';
    }
    return '#f44336';
  }
}
